import { Injectable } from '@angular/core';
import { Config, HttpMethod } from '@mitel/cloudlink-sdk';
import { environment } from './../../../environments/environment';
@Injectable({ providedIn: 'root' })
export class MiCollabService {
    private miCollabService: any;

    constructor() {
      this.miCollabService = {
        baseUrl: environment.tunnelUrl,
        baseUrlWithVersion: environment.tunnelUrlWithVersion,
        httpService: <HttpMethod>Config.httpService,

        async getMiCollabConfiguration(accountId: string, siteId: string): Promise<any> {
          let url = `${this.baseUrlWithVersion}/premise/accounts/${accountId}/sites/${siteId}/proxy/micollab/mslrest/msl/v1/configuration/`; //need final backslash else will get 403s
          
          return await this.httpService.get({ url })
            .then((response: any) => response.body);
        },
        async getMiCollabNetworkElements(accountId: string, siteId: string): Promise<any> {
          let url = `${this.baseUrlWithVersion}/premise/accounts/${accountId}/sites/${siteId}/proxy/micollab/mslrest/mas/v1/usp/networkelement`;
          
          return await this.httpService.get({ url })
            .then((response: any) => response.body);
        },
        async getMiCollabNetworkElementsForCLD(componentId: string): Promise<any> {
          let url = `${this.baseUrl}/mslrest/mas/v1/usp/networkelement`;
          let headers = {
            'x-mitel-tunnel-component-id': componentId,
            'x-mitel-tunnel-service': 'adminapi'
          };

          return await this.httpService.get({ url, headers })
            .then((response: any) => response.body);
        },
        async doesMiCollabHaveMSTeamsIntegration(accountId: string, siteId: string): Promise<any> {
          let url = `${this.baseUrlWithVersion}/premise/accounts/${accountId}/sites/${siteId}/proxy/micollab/mslrest/admin/api/v1/settings/MsTeamsIntegration`;
          
          return await this.httpService.get({ url })
            .then((response: any) => response.body);
        },
        async doesMiCollabHaveMSTeamsIntegrationForCLD(componentId: string): Promise<any> {
          let url = `${this.baseUrl}/mslrest/admin/api/v1/settings/MsTeamsIntegration`;
          let headers = {
            'x-mitel-tunnel-component-id': componentId,
            'x-mitel-tunnel-service': 'adminapi'
          };

          return await this.httpService.get({ url, headers })
            .then((response: any) => response.body);
        },
        async enableMiCollabMSTeamsIntegration(accountId: string, siteId: string, enable: boolean): Promise<any> {
          let url = `${this.baseUrlWithVersion}/premise/accounts/${accountId}/sites/${siteId}/proxy/micollab/mslrest/admin/api/v1/settings/MsTeamsIntegration`;
          
          let body = { enabled: enable }
          return await this.httpService.put({ url, body })
            .then((response: any) => response.body);
        },
        async enableMiCollabMSTeamsIntegrationForCLD(componentId: string, enable: boolean): Promise<any> {
          let url = `${this.baseUrl}/mslrest/admin/api/v1/settings/MsTeamsIntegration`;
          let headers = {
            'x-mitel-tunnel-component-id': componentId,
            'x-mitel-tunnel-service': 'adminapi'
          }; 
          let body = { enabled: enable }
          return await this.httpService.put({ url, headers, body })
            .then((response: any) => response.body);
        },
        async getMiCollabSettings(accountId: string, siteId: string): Promise<any> {
          let url = `${this.baseUrlWithVersion}/premise/accounts/${accountId}/sites/${siteId}/settings/micollab`;

          return await this.httpService.get({ url })
            .then((response: any) => response.body);
        },
        async getNetworkServicesById( serviceId: string, componentId?: string): Promise<any> {
          let url = `${this.baseUrl}/api/v1/proxy/micollab/mslrest/mas/v1/usp/network-services/${serviceId}`;
           
          let headers = {};

          if (componentId) {
            headers['x-mitel-tunnel-service'] = 'adminapi';
            headers['x-mitel-tunnel-component-id'] = componentId;
          } else {
            headers['x-mitel-tunnel-service'] = '*';
            headers['x-mitel-tunnel-component'] = '*';
          }

          return await this.httpService.get({ url, headers })
            .then((response: any) => response.body);
        }
      }
    }
  
    public async getMiCollabConfiguration(accountId: string, siteId: string): Promise<any> {
      try {
        let config = await this.miCollabService.getMiCollabConfiguration(accountId, siteId);
        return Promise.resolve(config);
      } catch (error) {
        if(error && error.statusCode === 404){
          console.warn("No MiCollab configuration found: ", error);
          return Promise.resolve('not found');
        }
        else{
          console.warn("Error getting MiCollab configuration: ", error);
          return Promise.reject(null);
        }
      }
    }

    public async getMiCollabNetworkElements(accountId: string, siteId: string): Promise<any> {
      try {
        let networkElements = await this.miCollabService.getMiCollabNetworkElements(accountId, siteId);
        return Promise.resolve(networkElements);
      } catch (error) {
        console.warn("Error getting network elements from MiCollab: ", error);
        return Promise.reject(null);
      }
    }

    public async getMiCollabNetworkElementsForCLD(componentId: string): Promise<any> {
      try {
        let networkElements = await this.miCollabService.getMiCollabNetworkElementsForCLD(componentId);
        return Promise.resolve(networkElements);
      } catch (error) {
        console.warn("Error getting network elements from MiCollab - CLD: ", error);
        return Promise.reject(null);
      }
    }
 
    // not in use right now, will remove if it continues not to be needed
    public async doesMiCollabHaveMSTeamsIntegration(accountId: string, siteId: string): Promise<any> {
      try {
        let hasMSTeams = await this.miCollabService.doesMiCollabHaveMSTeamsIntegration(accountId, siteId);
        // because the API is changing so I am trying to handle both situations
        if ( hasMSTeams && hasMSTeams.enabled != undefined )
          return hasMSTeams.enabled;
        else
          return hasMSTeams;
      } 
      catch (error) 
      {
        console.warn("Error getting MSTeams integration status from MiCollab: ", error);
        return false; // at this point there is no need for an error condition
      }
    }

    // client needs the error to determine what the issue is
    public async doesMiCollabHaveMSTeamsIntegrationWithError(accountId: string, siteId: string): Promise<any> {
      try
      {
        let hasMSTeams = await this.miCollabService.doesMiCollabHaveMSTeamsIntegration(accountId, siteId);
        // because the API is changing so I am trying to handle both situations
        if ( hasMSTeams && hasMSTeams.enabled != undefined )
          return hasMSTeams.enabled;
        else
          return hasMSTeams;
      }
      catch (error)
      {
        console.warn("Error getting MSTeams integration status from MiCollab: ", error);
        throw(error)
      }
    }

    public async doesMiCollabHaveMSTeamsIntegrationWithErrorForCLD(componentId: String): Promise<any> {
      try {
        let hasMSTeams = await this.miCollabService.doesMiCollabHaveMSTeamsIntegrationForCLD(componentId);
        if (hasMSTeams && hasMSTeams.enabled != undefined)
          return hasMSTeams.enabled;
        else
          return hasMSTeams;
      }
      catch (error) {
        console.warn("Error getting MSTeams integration status from MiCollab - CLD: ", error);
        throw(error)
      }
    }

    public enableMiCollabMSTeamsIntegration(accountId: string, siteId: string, enable: boolean): Promise<any> {
      return this.miCollabService.enableMiCollabMSTeamsIntegration(accountId, siteId, enable);
    }
  
    public enableMiCollabMSTeamsIntegrationForCLD(componentId: string, enable: boolean): Promise<any> {
      return this.miCollabService.enableMiCollabMSTeamsIntegrationForCLD(componentId, enable);
    }

    public async isMiCollabConfigured(accountId: string, siteId: string): Promise<any> {
      try {
        let settings = await this.miCollabService.getMiCollabSettings(accountId, siteId);
        if ( settings )
          return true;
        else
          return false
      } catch (error) {
        console.warn("Error getting setting from MiCollab: ", error);
        return false;
      }
    }

    public async getNetworkServicesById(serviceId: string, componentId?: string): Promise<any> {
      //see https://mitel.atlassian.net/browse/SAS-9840 for details
      if(!serviceId){
        console.error("Error getting network services by id: missing request details");
        return Promise.reject(null);
      }
      try {
        let networkService = await this.miCollabService.getNetworkServicesById(serviceId, componentId);
        return networkService;
      } catch (error) {
        console.error("Error getting network services by id: ", JSON.stringify(error));
        return Promise.reject(error);
      }
    }
}